<template>
	 <div>
		
	<div class="wrap" v-if="isMobile">
		 <div class="mnotice_list">
			<div v-for="item in noticeArr" v-bind:key="item.ID" >
				<router-link :to="'details/'+item.ID" active-class="hover">{{item.Title}}<span class="fr">{{formatDate(item.CreateDate)}}</span></router-link>
			</div>

			<div class="pagination">
				<el-pagination background layout="prev, pager, next , jumper" :hide-on-single-page="true" :pager-count=5 :total="totalCount" :page-size="pageSize" :current-page="pageIndex" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
        </div>
	</div>
	 <div v-else class="content">
        <div class="notice_list">
			<div v-for="item in noticeArr" v-bind:key="item.ID" >
				<router-link :to="'details/'+item.ID" active-class="hover">{{item.Title}}<span class="fr">{{formatDate(item.CreateDate)}}</span></router-link>
			</div>

			<div class="pagination">
				<el-pagination background layout="prev, pager, next , jumper" :hide-on-single-page="true" :pager-count=5 :total="totalCount" :page-size="pageSize" :current-page="pageIndex" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
        </div>
		
	</div>
	 </div>
</template>
<style scoped>
	
.notice_list { margin:16px 0; padding-top:16px;  background:#fff;min-height: 736px;overflow: hidden; }
.notice_list a{ display:block;  padding:0 24px; height:48px; line-height:48px;color: #747474;font-size: 14px;}
.notice_list a span{ color:#aaa;}
.notice_list a:hover{ background:#eee;  }

.mnotice_list { margin:1rem 0; padding-top:1.3rem;  background:#fff;overflow: hidden; }
.mnotice_list a{ display:block;  padding:0 1.2rem; height:3rem; line-height:3rem;color: #747474;font-size: 1.2rem; }
.mnotice_list a span{ color:#aaa;}
.mnotice_list a:hover{ background:#eee;  }


</style>
<script>   
	export default {
		name: 'notice',
		methods: {
			list(){
				const self = this;
				self.http.ajaxGet("NewsList?PageSize="+self.pageSize+"&PageIndex="+self.pageIndex+"&Type=1",function(res){
                if(res.ReturnCode == 1){
					self.noticeArr=res.Result;
					self.totalCount=parseInt(res.Message);

                }else{
                    self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
                }	
                },function(err){
                    self.$alert(err, '错误', {confirmButtonText: '确定'});
                })
			},
			handleCurrentChange(val){
				this.pageIndex=val;
			    this.list();
			},
			formatDate(date){
				return this.http.dateFormat1("yyyy-MM-dd",date);
        	}
		},
		data() {
			return {
				pageIndex:1,
				totalCount:0,
			    noticeArr:[]              //公告
			}
		},
		computed:{
			pageSize(){
				return this.$store.getters.pageSize;
      		},
			isMobile(){
			return this.common.isMobile();
			}
		},
		mounted: function () {
			this.list();
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/notice.vue